import { HotkeyNavListController } from '../../../shared/controllers/hotkey.nav.list.controller';
export default {
  template: require('./list.html'),
  controller: HotkeyNavListController,
  controllerAs: 'ContentActivityListController',
  bindings: {
    downKeyDescriptionText: '<',
    isActiveSelected: '<',
    items: '<',
    onItemSelected: '&',
    selectedItem: '<',
    upKeyDescriptionText: '<'
  }
};